

export default({
    data() {
        return {
            //
        }
    },
})
